import React, { useEffect, useState } from "react";
import NavBar from "../component/NavBar";
import Footer from "../component/Footer";

import '../assets/css/style.css';

import { Slide } from 'react-slideshow-image'
import 'react-slideshow-image/dist/styles.css'
import '../style/HomeScreen.css'
import ContactUsUI from '../component/ContactUsUI';
import axios from "axios";
import HomeScreenUI from "../component/HomeScreenUI";
import HangingBannerUI from '../component/HangingBannerUI'
import $ from "jquery";
import HeroUI from '../component/HeroUI'


const HomeScreen = () => {
  const [news, setNews] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [display, setDisplay] = useState(false)
  let slideImage = [
    {
      id: 1,
      image: 'https://rbiretaildirect.org.in/common/img/help/Welcome.png',
    },
    {
      id: 2,
      image: 'https://rbiretaildirect.org.in/common/img/help/Process.png',

    },
    {
      id: 3,
      image: 'https://rbiretaildirect.org.in/common/img/help/Requirements.png',

    },
    {
      id: 4,
      image: 'https://rbiretaildirect.org.in/common/img/help/Tracking.png',

    },
    {
      id: 5,
      image: 'https://rbiretaildirect.org.in/common/img/help/Closing.png',
      text: 'Click here to know more about the KYC process'
    }

  ]
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  useEffect(() => {

    $("#rd").click(function () {
      window.location.hash = "#/FaqRbiRetailDirect";
    });

    $("#gs").click(function () {
      window.location.hash = "#/FaqGovernmentActRegulations";
    });

    $("#pi").click(function () {
      window.location.hash = "#/FaqPrimaryIssuances";
    });

    $("#gb").click(function () {
      window.location.hash = "#/FaqGoldBonds";
    });

    $("#sm").click(function () {
      window.location.hash = "#/FaqNdsOmSecondaryMarket";
    });

  });

  useEffect(() => {

    axios
      .get("api/api/news/highlights")
      .then((response) => {
        console.log("response-->>", response);
        if (response && response.data && response.data.length > 0) {
          setNews(response.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });
  }, []);
  function displaySet(dis) {
    setDisplay(dis)
  }
  return (
    <div>

      {display === true ?
        <div className="slide-container custSlideShowOverlay" >
          <p className="custClose" onClick={() => setDisplay(false)}>X</p>
          <Slide>
            {slideImage.map((slide, index) => (
              <div className="each-Slide" key={index}>
                <div className="image-container custSlideshow" >
                  {slide.text ? <a className="custLink" href="https://rbiretaildirect.org.in/common/pdf/rd-registration-help.pdf" target="_blank">{slide.text}</a> : null}
                  <img src={slide.image} />
                </div>

              </div>
            ))}
          </Slide>
        </div>
        : null}
      <NavBar />


      <HeroUI displaySet={displaySet} />

      <HomeScreenUI news={news} isLoading={isLoading} />

      <ContactUsUI />


      <Footer />
      <HangingBannerUI />

    </div>
  );
};

export default HomeScreen;
